export default {"src":"/_next/static/media/experince_icon.91da73cc.svg","height":92,"width":89,"blurWidth":0,"blurHeight":0};